import React, { FC } from 'react'

import { IconSimSwapProps } from './IconSimSwap.types'
import * as Styled from './styles/IconSimSwap.style'

import { nonThemeableRules } from '../../ruleSet'

const IconSimSwap: FC<IconSimSwapProps> = ({
  size = nonThemeableRules.defaultSize as number as IconSimSwapProps['size'],
  isResponsive = false,
}: IconSimSwapProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M15.371 19.633h4.734c.872 0 1.579.707 1.579 1.578v9.473a1.58 1.58 0 0 1-1.579 1.582h-4.734a1.58 1.58 0 0 1-1.582-1.582V21.21a1.58 1.58 0 0 1 1.582-1.578Z'
          stroke='#E60000'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M24.34 10.063h8.133L38 15.59v21.058a3.418 3.418 0 0 1-3.414 3.414h-10.54a3.418 3.418 0 0 1-3.327-2.644'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M26.95 22.695h4.734c.87 0 1.578.707 1.578 1.578v9.477c0 .871-.707 1.574-1.578 1.578h-4.735a1.785 1.785 0 0 1-.5-.082'
          stroke='#E60000'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M9.05 33.586V10.414A3.42 3.42 0 0 1 12.47 7h8.426l5.527 5.527v21.059A3.421 3.421 0 0 1 23 37H12.469a3.42 3.42 0 0 1-3.418-3.414Z'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconSimSwap
